import * as React from "react";
import type { SVGProps } from "react";
const SvgMinusSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#minus-small_svg__a)">
      <path fill="currentColor" d="M16 13H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2" />
    </g>
    <defs>
      <clipPath id="minus-small_svg__a">
        <path fill="#fff" d="M7 11h10v2H7z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMinusSmall;
